import { InMemoryCache } from '@apollo/client';

/**
 * Apollo's normalized cache (docs/development/FrontendGuidelines.md §5.5). Relies on default `id`/`__typename`
 * normalization — every entity type the schema returns has a stable `id` field. If a future type
 * lacks one, add a `keyFields` policy for it here rather than letting Apollo silently fail to
 * normalize it. No business type policies exist yet (no business schema); feature
 * modules add their own `typePolicies` entries here as they land, they do not create a second
 * cache instance.
 */
export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {},
    },
  },
});
